import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalLoadingService {
  public globalIndicatorSubject$ = new BehaviorSubject<boolean>(false);
  isLoadingManually: Array<string> = new Array<string>();
  isLoadingInterceptor = false;

  private interceptor = 'interceptor';


  constructor() { }

  startLoadingIndicator(target?: string): any {
    if (!target) {
      target = this.interceptor;
    }

    if (this.isLoadingManually.indexOf(target) === -1) {
      this.isLoadingManually.push(target);
    }

    this.updateIndicators(target);
  }

  stopLoadingIndicator(searchIndex?: string) {
    if (!searchIndex) {
      searchIndex  = this.interceptor;
    }
    const indexOf = this.isLoadingManually.indexOf(searchIndex);
    if (indexOf !== -1) {
      this.isLoadingManually.splice(indexOf, 1);
    }

    this.updateIndicators(searchIndex);
  }

  stopAllLoadingIndicator() {
    let availableLoaders = this.isLoadingManually;
    for (let indicator of availableLoaders) {
      this.stopLoadingIndicator(indicator);
    }

  }

  private updateIndicators(loadingType: string): Observable<any> {
    if (loadingType) {
      this.globalIndicatorSubject$.next(this.isLoadingManually.length !== 0);
    } else {
      this.globalIndicatorSubject$.next(this.isLoadingInterceptor);
    }
    return this.globalIndicatorSubject$.asObservable();
  }
}
